import React from 'react';
import './Footer.css';
import profilePic from '../../assets/perttu.jpg';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-contact-wrapper">
                    <img src={profilePic} alt="Perttu Mutka" className="footer-profile-pic" />
                    <div className="footer-section">
                        <p>perttumutka@gmail.com</p>
                        <p>+358 50 415 5066</p>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} REMENA. Kaikki oikeudet pidätetään.</p>
            </div>
        </footer>
    );
};

export default Footer;